import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

// tODO reimplement and remove all references, finally delete this component -> substitute by dialogComponent
@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
})
export class ConfirmDialogComponent {
  @Output() decision: EventEmitter<boolean> = new EventEmitter();
  @Input() title = $localize`:@@dialogs.confirm.title:Confirm dialog`;
  @Input()
  message = $localize`:@@dialogs.confirm.delete:Are you sure you want to delete this?`;
  @Input() confirmBtnTxt = $localize`:@@general.confirm:Confirm`;
  @Input() confirmBtnClass = "btn btn-primary";
  @Input() cancelBtnTxt = $localize`:@@general.cancel:Cancel`;
  @Input() cancelBtnClass = "btn btn-secondary";

  constructor(public activeModal: NgbActiveModal) {}

  onDecision(decision) {
    this.activeModal.close();
    this.decision.emit(decision);
  }
}
